/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import SystemControllerDtoApiRoleDeleteRequest from '../model/SystemControllerDtoApiRoleDeleteRequest';
import SystemControllerDtoApiRoleListRequest from '../model/SystemControllerDtoApiRoleListRequest';
import SystemControllerDtoApiRoleListResponse from '../model/SystemControllerDtoApiRoleListResponse';
import SystemControllerDtoApiRoleUpdateRequest from '../model/SystemControllerDtoApiRoleUpdateRequest';
import SystemControllerDtoFileListRequest from '../model/SystemControllerDtoFileListRequest';
import SystemControllerDtoFileListResponse from '../model/SystemControllerDtoFileListResponse';
import SystemControllerDtoFolderListRequest from '../model/SystemControllerDtoFolderListRequest';
import SystemControllerDtoFolderListResponse from '../model/SystemControllerDtoFolderListResponse';
import SystemControllerDtoGoogleStoreProductImageUpdateRequest from '../model/SystemControllerDtoGoogleStoreProductImageUpdateRequest';
import SystemControllerDtoGroupRoleCategoryListRequest from '../model/SystemControllerDtoGroupRoleCategoryListRequest';
import SystemControllerDtoGroupRoleCategoryListResponse from '../model/SystemControllerDtoGroupRoleCategoryListResponse';
import SystemControllerDtoGroupRoleUpdateRequest from '../model/SystemControllerDtoGroupRoleUpdateRequest';
import SystemControllerDtoMnGnbDetailRequest from '../model/SystemControllerDtoMnGnbDetailRequest';
import SystemControllerDtoMnGnbDetailResponse from '../model/SystemControllerDtoMnGnbDetailResponse';
import SystemControllerDtoMnGnbListResponse from '../model/SystemControllerDtoMnGnbListResponse';
import SystemControllerDtoMnGnbUploadRequest from '../model/SystemControllerDtoMnGnbUploadRequest';
import SystemControllerDtoMnLnbDetailRequest from '../model/SystemControllerDtoMnLnbDetailRequest';
import SystemControllerDtoMnLnbDetailResponse from '../model/SystemControllerDtoMnLnbDetailResponse';
import SystemControllerDtoMnLnbListRequest from '../model/SystemControllerDtoMnLnbListRequest';
import SystemControllerDtoMnLnbListResponse from '../model/SystemControllerDtoMnLnbListResponse';
import SystemControllerDtoMnLnbUploadRequest from '../model/SystemControllerDtoMnLnbUploadRequest';
import SystemControllerDtoMnSubLnbDetailRequest from '../model/SystemControllerDtoMnSubLnbDetailRequest';
import SystemControllerDtoMnSubLnbDetailResponse from '../model/SystemControllerDtoMnSubLnbDetailResponse';
import SystemControllerDtoMnSubLnbListRequest from '../model/SystemControllerDtoMnSubLnbListRequest';
import SystemControllerDtoMnSubLnbListResponse from '../model/SystemControllerDtoMnSubLnbListResponse';
import SystemControllerDtoMnSubLnbUploadRequest from '../model/SystemControllerDtoMnSubLnbUploadRequest';
import SystemControllerDtoSysMaintenanceCreateRequest from '../model/SystemControllerDtoSysMaintenanceCreateRequest';
import SystemControllerDtoSysMaintenanceInfoRequest from '../model/SystemControllerDtoSysMaintenanceInfoRequest';
import SystemControllerDtoSysMaintenanceInfoResponse from '../model/SystemControllerDtoSysMaintenanceInfoResponse';
import SystemControllerDtoSysMaintenanceListRequest from '../model/SystemControllerDtoSysMaintenanceListRequest';
import SystemControllerDtoSysMaintenanceListResponse from '../model/SystemControllerDtoSysMaintenanceListResponse';
import SystemControllerDtoSysMaintenanceRemoveRequest from '../model/SystemControllerDtoSysMaintenanceRemoveRequest';
import SystemControllerDtoSysMaintenanceUpdateRequest from '../model/SystemControllerDtoSysMaintenanceUpdateRequest';

/**
* System service.
* @module api/SystemApi
* @version 1.0
*/
export default class SystemApi {

    /**
    * Constructs a new SystemApi. 
    * @alias module:api/SystemApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiSystemApiRoleDeletePost operation.
     * @callback module:api/SystemApi~apiSystemApiRoleDeletePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoApiRoleDeleteRequest} [systemControllerDtoApiRoleDeleteRequest] 
     * @param {module:api/SystemApi~apiSystemApiRoleDeletePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemApiRoleDeletePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoApiRoleDeleteRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/ApiRoleDelete', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemApiRoleListPost operation.
     * @callback module:api/SystemApi~apiSystemApiRoleListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoApiRoleListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoApiRoleListRequest} [systemControllerDtoApiRoleListRequest] 
     * @param {module:api/SystemApi~apiSystemApiRoleListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoApiRoleListResponse}
     */
    apiSystemApiRoleListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoApiRoleListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoApiRoleListResponse;
      return this.apiClient.callApi(
        '/api/System/ApiRoleList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemApiRoleUpdatePost operation.
     * @callback module:api/SystemApi~apiSystemApiRoleUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoApiRoleUpdateRequest} [systemControllerDtoApiRoleUpdateRequest] 
     * @param {module:api/SystemApi~apiSystemApiRoleUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemApiRoleUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoApiRoleUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/ApiRoleUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemFileListPost operation.
     * @callback module:api/SystemApi~apiSystemFileListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoFileListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoFileListRequest} [systemControllerDtoFileListRequest] 
     * @param {module:api/SystemApi~apiSystemFileListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoFileListResponse}
     */
    apiSystemFileListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoFileListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoFileListResponse;
      return this.apiClient.callApi(
        '/api/System/FileList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemFolderListPost operation.
     * @callback module:api/SystemApi~apiSystemFolderListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoFolderListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoFolderListRequest} [systemControllerDtoFolderListRequest] 
     * @param {module:api/SystemApi~apiSystemFolderListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoFolderListResponse}
     */
    apiSystemFolderListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoFolderListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoFolderListResponse;
      return this.apiClient.callApi(
        '/api/System/FolderList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemGoogleStoreProductImageUpdatePost operation.
     * @callback module:api/SystemApi~apiSystemGoogleStoreProductImageUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoGoogleStoreProductImageUpdateRequest} [systemControllerDtoGoogleStoreProductImageUpdateRequest] 
     * @param {module:api/SystemApi~apiSystemGoogleStoreProductImageUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemGoogleStoreProductImageUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoGoogleStoreProductImageUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/GoogleStoreProductImageUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemGroupRoleCategoryListPost operation.
     * @callback module:api/SystemApi~apiSystemGroupRoleCategoryListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoGroupRoleCategoryListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoGroupRoleCategoryListRequest} [systemControllerDtoGroupRoleCategoryListRequest] 
     * @param {module:api/SystemApi~apiSystemGroupRoleCategoryListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoGroupRoleCategoryListResponse}
     */
    apiSystemGroupRoleCategoryListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoGroupRoleCategoryListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoGroupRoleCategoryListResponse;
      return this.apiClient.callApi(
        '/api/System/GroupRoleCategoryList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemGroupRoleUpdatePost operation.
     * @callback module:api/SystemApi~apiSystemGroupRoleUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoGroupRoleUpdateRequest} [systemControllerDtoGroupRoleUpdateRequest] 
     * @param {module:api/SystemApi~apiSystemGroupRoleUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemGroupRoleUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoGroupRoleUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/GroupRoleUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemMnGnbDetailPost operation.
     * @callback module:api/SystemApi~apiSystemMnGnbDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoMnGnbDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoMnGnbDetailRequest} [systemControllerDtoMnGnbDetailRequest] 
     * @param {module:api/SystemApi~apiSystemMnGnbDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoMnGnbDetailResponse}
     */
    apiSystemMnGnbDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoMnGnbDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoMnGnbDetailResponse;
      return this.apiClient.callApi(
        '/api/System/MnGnbDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemMnGnbListPost operation.
     * @callback module:api/SystemApi~apiSystemMnGnbListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoMnGnbListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/SystemApi~apiSystemMnGnbListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoMnGnbListResponse}
     */
    apiSystemMnGnbListPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoMnGnbListResponse;
      return this.apiClient.callApi(
        '/api/System/MnGnbList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemMnGnbUploadPost operation.
     * @callback module:api/SystemApi~apiSystemMnGnbUploadPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoMnGnbUploadRequest} [systemControllerDtoMnGnbUploadRequest] 
     * @param {module:api/SystemApi~apiSystemMnGnbUploadPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemMnGnbUploadPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoMnGnbUploadRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/MnGnbUpload', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemMnLnbDetailPost operation.
     * @callback module:api/SystemApi~apiSystemMnLnbDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoMnLnbDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoMnLnbDetailRequest} [systemControllerDtoMnLnbDetailRequest] 
     * @param {module:api/SystemApi~apiSystemMnLnbDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoMnLnbDetailResponse}
     */
    apiSystemMnLnbDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoMnLnbDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoMnLnbDetailResponse;
      return this.apiClient.callApi(
        '/api/System/MnLnbDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemMnLnbListPost operation.
     * @callback module:api/SystemApi~apiSystemMnLnbListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoMnLnbListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoMnLnbListRequest} [systemControllerDtoMnLnbListRequest] 
     * @param {module:api/SystemApi~apiSystemMnLnbListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoMnLnbListResponse}
     */
    apiSystemMnLnbListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoMnLnbListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoMnLnbListResponse;
      return this.apiClient.callApi(
        '/api/System/MnLnbList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemMnLnbUploadPost operation.
     * @callback module:api/SystemApi~apiSystemMnLnbUploadPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoMnLnbUploadRequest} [systemControllerDtoMnLnbUploadRequest] 
     * @param {module:api/SystemApi~apiSystemMnLnbUploadPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemMnLnbUploadPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoMnLnbUploadRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/MnLnbUpload', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemMnSubLnbDetailPost operation.
     * @callback module:api/SystemApi~apiSystemMnSubLnbDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoMnSubLnbDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoMnSubLnbDetailRequest} [systemControllerDtoMnSubLnbDetailRequest] 
     * @param {module:api/SystemApi~apiSystemMnSubLnbDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoMnSubLnbDetailResponse}
     */
    apiSystemMnSubLnbDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoMnSubLnbDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoMnSubLnbDetailResponse;
      return this.apiClient.callApi(
        '/api/System/MnSubLnbDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemMnSubLnbListPost operation.
     * @callback module:api/SystemApi~apiSystemMnSubLnbListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoMnSubLnbListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoMnSubLnbListRequest} [systemControllerDtoMnSubLnbListRequest] 
     * @param {module:api/SystemApi~apiSystemMnSubLnbListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoMnSubLnbListResponse}
     */
    apiSystemMnSubLnbListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoMnSubLnbListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoMnSubLnbListResponse;
      return this.apiClient.callApi(
        '/api/System/MnSubLnbList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemMnSubLnbUploadPost operation.
     * @callback module:api/SystemApi~apiSystemMnSubLnbUploadPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoMnSubLnbUploadRequest} [systemControllerDtoMnSubLnbUploadRequest] 
     * @param {module:api/SystemApi~apiSystemMnSubLnbUploadPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemMnSubLnbUploadPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoMnSubLnbUploadRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/MnSubLnbUpload', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemSysMaintenanceCreatePost operation.
     * @callback module:api/SystemApi~apiSystemSysMaintenanceCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoSysMaintenanceCreateRequest} [systemControllerDtoSysMaintenanceCreateRequest] 
     * @param {module:api/SystemApi~apiSystemSysMaintenanceCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemSysMaintenanceCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoSysMaintenanceCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/SysMaintenanceCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemSysMaintenanceInfoPost operation.
     * @callback module:api/SystemApi~apiSystemSysMaintenanceInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoSysMaintenanceInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoSysMaintenanceInfoRequest} [systemControllerDtoSysMaintenanceInfoRequest] 
     * @param {module:api/SystemApi~apiSystemSysMaintenanceInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoSysMaintenanceInfoResponse}
     */
    apiSystemSysMaintenanceInfoPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoSysMaintenanceInfoRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoSysMaintenanceInfoResponse;
      return this.apiClient.callApi(
        '/api/System/SysMaintenanceInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemSysMaintenanceListPost operation.
     * @callback module:api/SystemApi~apiSystemSysMaintenanceListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SystemControllerDtoSysMaintenanceListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoSysMaintenanceListRequest} [systemControllerDtoSysMaintenanceListRequest] 
     * @param {module:api/SystemApi~apiSystemSysMaintenanceListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SystemControllerDtoSysMaintenanceListResponse}
     */
    apiSystemSysMaintenanceListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoSysMaintenanceListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SystemControllerDtoSysMaintenanceListResponse;
      return this.apiClient.callApi(
        '/api/System/SysMaintenanceList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemSysMaintenanceRemovePost operation.
     * @callback module:api/SystemApi~apiSystemSysMaintenanceRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoSysMaintenanceRemoveRequest} [systemControllerDtoSysMaintenanceRemoveRequest] 
     * @param {module:api/SystemApi~apiSystemSysMaintenanceRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemSysMaintenanceRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoSysMaintenanceRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/SysMaintenanceRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemSysMaintenanceTerminatePost operation.
     * @callback module:api/SystemApi~apiSystemSysMaintenanceTerminatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/SystemApi~apiSystemSysMaintenanceTerminatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemSysMaintenanceTerminatePost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/SysMaintenanceTerminate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemSysMaintenanceUpdatePost operation.
     * @callback module:api/SystemApi~apiSystemSysMaintenanceUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SystemControllerDtoSysMaintenanceUpdateRequest} [systemControllerDtoSysMaintenanceUpdateRequest] 
     * @param {module:api/SystemApi~apiSystemSysMaintenanceUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemSysMaintenanceUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['systemControllerDtoSysMaintenanceUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/SysMaintenanceUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiSystemUploadFilePost operation.
     * @callback module:api/SystemApi~apiSystemUploadFilePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {File} file 
     * @param {String} folderName 
     * @param {Object} opts Optional parameters
     * @param {Number} [container] 
     * @param {String} [fileName] 
     * @param {module:api/SystemApi~apiSystemUploadFilePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiSystemUploadFilePost(file, folderName, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling apiSystemUploadFilePost");
      }
      // verify the required parameter 'folderName' is set
      if (folderName === undefined || folderName === null) {
        throw new Error("Missing the required parameter 'folderName' when calling apiSystemUploadFilePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'File': file,
        'FolderName': folderName,
        'Container': opts['container'],
        'FileName': opts['fileName']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/System/UploadFile', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
